import React from "react";
import { H4 } from "../../../../AbstractElements";
import { FormGroup, Label } from "reactstrap";

export default function ReportsPermissions({ register, handleAll }) {
  return (
    <>
      {" "}
      <H4 attrH4={{ className: "mb-3 mt-2" }}>Reporte</H4>
      <FormGroup className="m-t-15 m-checkbox-inline m-0">
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="list_activity"
            type="checkbox"
            {...register("permissions.list_activity", {})}
          />
          <Label for="list_activity">
            {Option}
            <span className="digits"> Ver</span>
          </Label>
        </div>
      </FormGroup>
    </>
  );
}
